import { render, staticRenderFns } from "./ShareCustomersXcb.vue?vue&type=template&id=91039bb2"
import script from "./ShareCustomersXcb.vue?vue&type=script&lang=js"
export * from "./ShareCustomersXcb.vue?vue&type=script&lang=js"
import style0 from "./ShareCustomersXcb.vue?vue&type=style&index=0&id=91039bb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports